import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar, MapPin, ArrowRight } from "lucide-react";

const campaignsData = {
  "lee-royalty-orphanage": {
    title: "A Day of Love, Hope & Impact at Lee Royalty Orphanage Center",
    date: "February 22, 2026",
    location: "Lee Royalty Orphanage Center, Benin City, Edo State",
    category: "Orphanage Outreach",
    images: ["/leeroyalty/img1.jpg", "/leeroyalty/img2.jpg", "/leeroyalty/img3.jpg", "/leeroyalty/img4.jpg", "/leeroyalty/img5.jpg", "/leeroyalty/img6.jpg", "/leeroyalty/img7.jpg", "/leeroyalty/img8.jpg"],
    content: `A day of love, hope, and meaningful impact at Lee Royalty Orphanage Center, Benin City, Edo State. 🤍

The Oshoke Alasa Foundation was honored to spend time with these incredible children, sharing support, essentials, and most importantly, reminding them that they are seen, valued, and deeply loved.

This outreach reflects our commitment to uplifting vulnerable communities and investing in the future of our children. Every smile we witnessed is a reminder that compassion has the power to change lives.

We remain dedicated to creating opportunities, spreading hope, and building a stronger, more inclusive society—one life at a time.

Together, we can do more. 🤍`,
  },
  "thousand-smiles": {
    title: "A Thousand Smiles - IDP Camp Feeding Initiative",
    date: "December 10, 2025",
    location: "Area 1 IDP Camp, Abuja",
    category: "Community Outreach",
    images: ["/10thdecember/img1.jpeg", "/10thdecember/img2.jpeg", "/10thdecember/img3.jpeg", "/10thdecember/img4.jpeg", "/10thdecember/img5.jpeg", "/10thdecember/img6.jpeg", "/10thdecember/img7.jpeg", "/10thdecember/img8.jpeg", "/10thdecember/img9.jpeg", "/10thdecember/img10.jpeg", "/10thdecember/img11.jpeg", "/10thdecember/img12.jpeg", "/10thdecember/img13.jpeg", "/10thdecember/img14.jpeg", "/10thdecember/img15.jpeg", "/10thdecember/img16.jpeg", "/10thdecember/img17.jpeg", "/10thdecember/img18.jpeg", "/10thdecember/img19.jpeg", "/10thdecember/img20.jpeg"],
    content: `🌟 A Thousand Smiles - Bringing Hope to IDP Camp 🌟

On December 10th, 2025, the Oshoke Alasa Foundation successfully carried out our feeding initiative at Area 1 IDP Camp, Abuja. It was a day filled with compassion, connection, and the joy of making a real difference in the lives of displaced families.

What We Accomplished

Thanks to the generous support of our donors and volunteers, we were able to provide:
✅ Nutritious meals and food items
✅ Clothing for families in need
✅ Essential toiletries and hygiene supplies
✅ Words of encouragement and hope

The Impact

The smiles on the faces of children and families at the camp were priceless. For many, this initiative was not just about receiving essential supplies—it was about knowing that they are not forgotten, that they are valued, and that there are people who care.

Community Spirit

This initiative brought together volunteers, donors, and community members united by a common purpose: to uplift lives and spread hope. The energy and enthusiasm were contagious as we worked together to serve the families.

Looking Forward

The success of "A Thousand Smiles" has inspired us to continue our work with displaced communities. We remain committed to being a source of hope and support for those who need it most.

Thank you to everyone who contributed, volunteered, and supported this initiative. Together, we truly made a difference! ❤️`,
  },
  "charity-faith-hope": {
    title: "Oshoke Alasa Foundation's First Visit to Charity Faith and Hope Orphanage Home",
    date: "April 15, 2025",
    location: "Abuja, Nigeria",
    category: "Orphanage Outreach",
    images: ["/charityfaith/img1.jpeg", "/charityfaith/img2.jpeg", "/charityfaith/img3.jpeg", "/charityfaith/img4.jpeg", "/charityfaith/img5.jpeg", "/charityfaith/img6.jpeg"],
    content: `On Tuesday, April 15th, our team had the privilege of visiting Charity Faith and Hope Orphanage Home to spend quality time with the children and share love.

We played games, told stories, listened to their dreams—and most importantly, we created lasting memories. It was a truly enriching and heartwarming experience!

The children welcomed us with open arms and bright smiles. We spent hours engaging with them, learning about their aspirations, and reminding them that they are loved and valued.

This visit reinforced our commitment to supporting children across Nigeria and ensuring they have the opportunity to dream big and achieve their goals.`,
  },
  "gods-pavilion": {
    title: "God's Pavilion Orphanage Outreach",
    date: "April 22, 2025",
    location: "Apo Waru, Abuja-FCT",
    category: "Orphanage Outreach",
    images: ["/gallery/img7.jpeg", "/gallery/img8.jpeg", "/gallery/img9.jpeg", "/gallery/img10.jpeg", "/gallery/img11.jpeg"],
    content: `On April 22nd, our team had the privilege of spending a heartwarming day at God's Pavilion Orphanage Home at Apo Waru, Abuja-FCT.

We laughed, played games, shared stories, and listened to the dreams of these amazing children. It was a truly touching and inspiring experience.

Every child we met had a unique story and incredible dreams for their future. Some wanted to be doctors, others teachers, and some aspired to be engineers. We encouraged each one of them to hold onto their dreams.

The joy in their eyes as we spent time with them reminded us why this work is so important. These children deserve love, support, and the opportunity to thrive.`,
  },
  "national-hospital": {
    title: "National Hospital Abuja Medical Support",
    date: "May 8, 2025",
    location: "National Hospital, Abuja",
    category: "Healthcare",
    images: ["/may8th/img1.jpeg", "/may8th/img2.jpeg", "/may8th/img3.jpeg", "/may8th/img4.jpeg", "/may8th/img5.jpeg", "/may8th/img6.jpeg", "/may8th/img7.jpeg", "/may8th/img8.jpeg", "/may8th/img9.jpeg", "/may8th/img10.jpeg"],
    content: `On May 8th, 2025, the Oshoke Alasa Foundation team visited National Hospital Abuja, where we were privileged to stand in the gap for many in need. ❤️

We paid several medical bills for patients and gave out essential items to the sick. It was a day filled with compassion, connection, and care — reminding us that even in pain, hope and healing are possible when we show up for one another.

Every smile, every "thank you," and every relieved tear reminded us why we do what we do. This mission isn't just about giving — it's about being present, offering love, and restoring dignity. 🙏🏾

We met families who had been struggling to pay for treatment, patients who had lost hope, and healthcare workers doing their best with limited resources. Our support brought relief and renewed hope to many.`,
  },
  "shoes-for-all": {
    title: "Shoes For All - Empowering Hands, Crafting Futures",
    date: "2025",
    location: "Abuja, Nigeria",
    category: "Skills Training",
    images: ["/shoesforall/img1.jpeg", "/shoesforall/img2.jpeg", "/shoesforall/img3.jpeg", "/shoesforall/img4.jpeg", "/shoesforall/img5.jpeg", "/shoesforall/img6.jpeg", "/shoesforall/img7.jpeg", "/shoesforall/img8.jpeg", "/shoesforall/img9.jpeg", "/shoesforall/img10.jpeg", "/shoesforall/img11.jpeg", "/shoesforall/img12.jpeg", "/shoesforall/img13.jpeg", "/shoesforall/img14.jpeg", "/shoesforall/img15.jpeg"],
    content: `SHOES FOR ALL - Empowering Hands. Crafting Futures.

The Oshoke Alasa Foundation, in collaboration with @thegirlchildvsi and @its_feyishayo of Feyidbrand, proudly launched our 3-day Footwear-Making Workshop — training young women in hands-on shoemaking skills that can change the course of their futures.

From stitching soles to shaping dreams, the workshop was filled with passion, creativity, and purpose. We're not just making shoes — we're building confidence and creating economic pathways for women across our communities.

The participants learned:
• Basic footwear design principles
• Material selection and preparation
• Cutting and stitching techniques
• Sole attachment and finishing
• Business basics for selling their products

By the end of the workshop, each participant had created their own pair of shoes and gained skills they can use to start their own businesses or find employment in the footwear industry.`,
  },
  "police-appreciation": {
    title: "Police Appreciation Outreach",
    date: "August 21, 2025",
    location: "Durumi Police Division, Abuja",
    category: "Community Outreach",
    images: ["/policeappreciation/img1.jpeg", "/policeappreciation/img2.jpeg", "/policeappreciation/img3.jpeg", "/policeappreciation/img4.jpeg", "/policeappreciation/img5.jpeg", "/policeappreciation/img6.jpeg", "/policeappreciation/img7.jpeg", "/policeappreciation/img8.jpeg"],
    content: `✨ Police Appreciation Outreach ✨

On Thursday, 21st August 2025, Oshoke Alasa Foundation visited the Durumi Police Division, Abuja to honor the brave men and women who dedicate their lives to keeping us safe. 💙

Through this outreach, we came to:
✅ Show Gratitude 🙏
✅ Provide Support 🤝
✅ Promote Engagement 💬
✅ Encourage Well-being 🌿

This initiative is more than just giving — it's about building bridges of friendship and understanding between the police and the people they serve. Together, we can strengthen trust, peace, and community love. ❤️

We provided refreshments, essential items, and words of encouragement to the officers. The response was overwhelming — many expressed their appreciation for being recognized and valued by the community.

This outreach is part of our broader mission to support all members of our community, including those who serve and protect us daily.`,
  },
  "nisa-hospital": {
    title: "Nisa Garki Hospital Outreach",
    date: "November 15, 2025",
    location: "Nisa Garki Hospital, Abuja",
    category: "Healthcare",
    images: ["/nisa/img1.jpeg", "/nisa/img2.jpeg", "/nisa/img3.jpeg", "/nisa/img4.jpeg", "/nisa/img5.jpeg", "/nisa/img6.jpeg", "/nisa/img7.jpeg", "/nisa/img8.jpeg", "/nisa/img9.jpeg", "/nisa/img10.jpeg", "/nisa/img11.jpeg", "/nisa/img12.jpeg", "/nisa/img13.jpeg", "/nisa/img14.jpeg", "/nisa/img15.jpeg"],
    content: `A day of giving, healing, and true human connection at Nisa Garki Hospital. ❤️

On 15th November 2025 in Abuja, the Oshoke Alasa Foundation stepped in once again—committed to touching lives, one act of love at a time.

We supported families by paying medical bills, shared heartfelt words of encouragement, and lifted spirits with prayers. We rejoiced with those receiving good news, and we stood beside those in pain, reminding them that they are never alone.

Every smile, every tear, every prayer shared reminds us why we do this.

Compassion is powerful. Love is healing. Humanity is everything.

This outreach touched the lives of numerous patients and their families, providing not just financial support but also emotional and spiritual encouragement during their most challenging times.`,
  },
};

const CampaignDetail = () => {
  const { id } = useParams();
  const campaign = campaignsData[id];

  if (!campaign) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Campaign not found</h1>
          <Link to="/campaigns" className="text-primary hover:underline">
            Back to Campaigns
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Hero */}
      <section className="bg-cream py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/campaigns" className="inline-flex items-center text-primary hover:underline mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Campaigns
          </Link>
          <div className="text-white text-xs font-medium px-3 py-1 rounded-full inline-block mb-4 bg-primary">
            {campaign.category}
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {campaign.title}
          </h1>
          <div className="flex flex-wrap gap-6 text-gray-600">
            <div className="flex items-center">
              <Calendar className="w-5 h-5 mr-2 text-primary" />
              {campaign.date}
            </div>
            <div className="flex items-center">
              <MapPin className="w-5 h-5 mr-2 text-primary" />
              {campaign.location}
            </div>
          </div>
        </div>
      </section>

      {/* Main Image */}
      <section className="py-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <img
            src={campaign.images[0]}
            alt={campaign.title}
            className="w-full h-[400px] md:h-[500px] object-cover rounded-2xl shadow-xl"
          />
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            {campaign.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-gray-600 leading-relaxed mb-6">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-12 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl font-bold text-gray-900 mb-8 text-center">Photo Gallery</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {campaign.images.map((image, index) => (
              <div key={index} className="aspect-square rounded-xl overflow-hidden shadow-lg">
                <img
                  src={image}
                  alt={`${campaign.title} - ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-6">
            Support Our Mission
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Your donation helps us continue making a difference in the lives of those who need it most.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/donate" className="bg-white text-primary hover:bg-gray-100 px-8 py-4 rounded-full font-medium text-sm transition-colors inline-flex items-center gap-2">
              DONATE NOW <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/campaigns" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-4 rounded-full font-medium text-sm transition-colors">
              VIEW MORE CAMPAIGNS
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CampaignDetail;
